module.exports = {"cards":{"type":"mini","content":[{"sub":"Better for Detail","body":""}],"title":"cards"},"fractal":{"type":"mini","content":[{"sub":"Better for Comparison","body":""}],"title":"fractal"},"Onboarding":{"type":"full","content":[{"sub":"","body":"Add a new AirPulse to this floor"}],"title":"Onboarding"}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/hoverTemplates/Floor.json
// module id = 408
// module chunks = 1